import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			component: () => import( /* webpackChunkName: "home" */ '../components/layout/Home'),
			redirect: '/login',
			meta: {
				title: ''
			},
			children:[
				{
					path: '/qcsj',
					component: () => import('../components/page/Applicationdraft/qcsj'),
					meta: {
						title: '期初数据',
						roles: ['qcsj']
					}
				},
				{
					path: '/home',
					component: () => import( /* webpackChunkName: "home" */ '../components/page/home/index.vue'),
					meta: {
						title: '首页',
						roles: ['home']
					},
				},
				{
					path: '/HomePageNew',
					component: () => import( /* webpackChunkName: "home" */ '../components/page/HomePageNew/index.vue'),
					meta: {
						title: '首页',
						roles: ['HomePageNew']
					},
				},
				{
					path: '/subject',
					component: () => import('../components/page/DataAcquisition/subject'),
					meta: {
						title: '科目余额表',
						roles: ['subject']
					}
				},{
					path: '/cyry',
					component: () => import('../components/page/DataGovernance/cyry'),
					meta: {
						title: '从业人员',
						roles: ['cyry']
					}
				},
				{
					path: '/nsreport',
					component: () => import('../components/page/DataAcquisition/nsreport'),
					meta: {
						title: '进项增值税',
						roles: ['nsreport']
					}
				},
				{
					path: '/iinvSubLeger',
					component: () => import('../components/page/DataAcquisition/iinvSubLeger'),
					meta: {
						title: '进项明细账',
						roles: ['iinvSubLeger']
					}
				},
				{
					path: '/tralvel',
					component: () => import('../components/page/DataAcquisition/tralvel'),
					meta: {
						title: '客运抵扣凭证',
						roles: ['tralvel']
					}
				},
				{
					path: '/AgricultureProducts',
					component: () => import('../components/page/DataAcquisition/AgricultureProducts'),
					meta: {
						title: '农产品收购发票',
						roles: ['AgricultureProducts']
					}
				},
				{
					path: '/dkdj',
					component: () => import('../components/page/DataAcquisition/dkdj'),
					meta: {
						title: '代扣代缴凭证',
						roles: ['dkdj']
					}
				},
				{
					path: '/customs',
					component: () => import('../components/page/DataAcquisition/customs'),
					meta: {
						title: '海关缴款书',
						roles: ['customs']
					}
				},
				{
					path: '/oinv',
					component: () => import('../components/page/DataAcquisition/oinv'),
					meta: {
						title: '销项增值税',
						roles: ['oinv']
					}
				},
				{
					path: '/subLeger',
					component: () => import('../components/page/DataAcquisition/subLeger'),
					meta: {
						title: '明细账',
						roles: ['subLeger']
					}
				},
				{
					path: '/jxzc',
					component: () => import('../components/page/DataGovernance/jxzc'),
					meta: {
						title: '进项转出',
						roles: ['jxzc']
					}
				},
				{
					path: '/qedk',
					component: () => import('../components/page/DataGovernance/qedk'),
					meta: {
						title: '全额抵扣',
						roles: ['qedk']
					}
				},
				{
					path: '/wpsr',
					component: () => import('../components/page/DataGovernance/wpsr'),
					meta: {
						title: '无票收入',
						roles: ['wpsr']
					}
				},
				{
					path: '/yhs',
					component: () => import('../components/page/DataGovernance/yhs'),
					meta: {
						title: '印花税',
						roles: ['yhs']
					}
				},
				{
					path: '/cztdsys',
					component: () => import('../components/page/DataGovernance/cztdsys'),
					meta: {
						title: '城镇土地使用税',
						roles: ['cztdsys']
					}
				},
				{
					path: '/hjbhs',
					component: () => import('../components/page/DataGovernance/hjbhs'),
					meta: {
						title: '环境保护税',
						roles: ['hjbhs']
					}
				},
				{
					path: '/yffygl',
					component: () => import('../components/page/DataGovernance/yffygl'),
					meta: {
						title: '研发费用管理',
						roles: ['yffygl']
					}
				},
				{
					path: '/yjxsxtz',
					component: () => import('../components/page/DataGovernance/yjxsxtz'),
					meta: {
						title: '永久性事项调整',
						roles: ['yjxsxtz']
					}
				},
				{
					path: '/zczjtx',
					component: () => import('../components/page/DataGovernance/zczjtx'),
					meta: {
						title: '资产折旧摊销',
						roles: ['zczjtx']
					}
				},
				{
					path: '/Draftgeneration',
					component: () => import('../components/page/Applicationdraft/Draftgeneration'),
					meta: {
						title: '底稿生成',
						roles: ['Draftgeneration']
					}
				},
				{
					path: '/xggj',
					component: () => import('../components/page/Applicationdraft/xggj'),
					meta: {
						title: '操作记录',
						roles: ['xggj']
					}
				},
				{
					path: '/gjck',
					component: () => import('../components/page/Applicationdraft/xggj'),
					meta: {
						title: '轨迹查看',
						roles: ['gjck']
					}
				},
				{
					path: '/bbmb',
					component: () => import('../components/page/Applicationdraft/bbmb'),
					meta: {
						title: '报表模板',
						roles: ['bbmb']
					}
				},
				{
					path: '/StructuralData',
					component: () => import('../components/page/Applicationdraft/StructuralData'),
					meta: {
						title: '结构化数据',
						roles: ['StructuralData']
					}
				},

				{
					path: '/sbjk',
					component: () => import('../components/page/Taxdeclaration/sbjk'),
					meta: {
						title: '申报缴款',
						roles: ['sbjk']
					}
				},
				{
					path: '/sbdbsz',
					component: () => import('../components/page/Taxdeclaration/sbdbsz'),
					meta: {
						title: '申报对比配置',
						roles: ['sbdbsz']
					}
				},
				{
					path: '/sbdbjg',
					component: () => import('../components/page/Taxdeclaration/sbdbjg'),
					meta: {
						title: '申报对比结果',
						roles: ['sbdbjg']
					}
				},
				{
					path: '/zcfg',
					component: () => import('../components/page/Taxknowledgebase/zcfg'),
					meta: {
						title: '政策法规',
						roles: ['zcfg']
					}
				},
				{
					path: '/cszd',
					component: () => import('../components/page/Taxknowledgebase/cszd'),
					meta: {
						title: '财税制度',
						roles: ['cszd']
					}
				},
				{
					path: '/csal',
					component: () => import('../components/page/Taxknowledgebase/csal'),
					meta: {
						title: '财税案例',
						roles: ['csal']
					}
				},
				{
					path: '/sjclzx',
					component: () => import('../components/page/TaxDiscrepancy/sjclzx'),
					meta: {
						title: '数据处理中心',
						roles: ['sjclzx']
					}
				},
				{
					path: '/xxtjbyl',
					component: () => import('../components/page/TaxDiscrepancy/xxtjbyl'),
					meta: {
						title: '销项调节表一览',
						roles: ['xxtjbyl']
					}
				},
				{
					path: '/ywlxgz',
					component: () => import('../components/page/TaxDiscrepancy/ywlxgz'),
					meta: {
						title: '业务类型规则',
						roles: ['ywlxgz']
					}
				},
				{
					path: '/requisitionIinv',
					component: () => import('../components/page/requisition/requisitionIinv'),
					meta: {
						title: '进项发票表',
						roles: ['requisitionIinv']
					}
				},
				{
					path: '/requisitionOinv',
					component: () => import('../components/page/requisition/requisitionOinv'),
					meta: {
						title: '销项发票表',
						roles: ['requisitionOinv']
					}
				},
				{
					path: '/requisitionDraft',
					component: () => import('../components/page/requisition/requisitionDraft'),
					meta: {
						title: '即征即退底稿',
						roles: ['requisitionDraft']
					}
				},
				{
					path: '/hmdgl',
					component: () => import('../components/page/Riskmanagement/hmdgl'),
					meta: {
						title: '灰名单管理',
						roles: ['hmdgl']
					}
				},
				{
					path: '/hztj',
					component: () => import('../components/page/Riskmanagement/hztj'),
					meta: {
						title: '指标监控',
						roles: ['hztj']
					}
				},
				{
					path: '/fxjk',
					component: () => import('../components/page/Riskmanagement/fxjk'),
					meta: {
						title: '风险监控',
						roles: ['fxjk']
					}
				}, {
                    path: '/ReportEditor',
                    component: () => import('../components/page/Riskmanagement/ReportEditor'),
                    meta: {
                        title: '风险报告',
                        roles: ['ReportEditor']
                    }
				}, {
					path: '/tzsz',
					component: () => import('../components/page/Riskmanagement/tzsz'),
					meta: {
						title: '通知设置',
						roles: ['tzsz']
					}
				},
				{
					path: '/tzmb',
					component: () => import('../components/page/Riskmanagement/tzmb'),
					meta: {
						title: '通知模板',
						roles: ['tzmb']
					}
				},
				{
					path: '/jkhz',
					component: () => import('../components/page/Riskmanagement/jkhz'),
					meta: {
						title: '监控汇总',
						roles: ['jkhz']
					}
				},
				{
					path: '/dgsh',
					component: () => import('../components/page/AuditCenter/dgsh'),
					meta: {
						title: '底稿审核',
						roles: ['dgsh']
					}
				},
				{
					path: '/zzsz',
					component: () => import('../components/page/ConfigurationCenter/zzsz'),
					meta: {
						title: '组织设置',
						roles: ['zzsz']
					}
				},
				{
					path: '/member',
					component: () => import('../components/page/ConfigurationCenter/member'),
					meta: {
						title: '人员管理',
						roles: ['member']
					}
				},
				{
					path: '/qxsz',
					component: () => import('../components/page/ConfigurationCenter/qxsz'),
					meta: {
						title: '权限管理',
						roles: ['qxsz']
					}
				},
				{
					path: '/MappingRules',
					component: () => import('../components/page/ConfigurationCenter/MappingRules'),
					meta: {
						title: '映射规则',
						roles: ['MappingRules']
					}
				},
				{
					path: '/TaxTaskDetail',
					component: () => import('../components/page/ConfigurationCenter/TaxTaskDetail'),
					meta: {
						title: '定时任务明细',
						roles: ['TaxTaskDetail']
					}
				},
				{
					path: '/TaxTask',
					component: () => import('../components/page/ConfigurationCenter/TaxTask'),
					meta: {
						title: '定时任务',
						roles: ['TaxTask']
					}
				},
				{
					path: '/BusinessTypeSet',
					component: () => import('../components/page/TaxDiscrepancy/BusinessTypeSet'),
					meta: {
						title: '业务类型管理',
						roles: ['BusinessTypeSet']
					}
				},
				{
					path: '/RequisitionRule',
					component: () => import('../components/page/ConfigurationCenter/RequisitionRule'),
					meta: {
						title: '即征即退规则',
						roles: ['RequisitionRule']
					}
				},
				{
					path: '/CopyrightMaintain',
					component: () => import('../components/page/ConfigurationCenter/CopyrightMaintain'),
					meta: {
						title: '著作权维护',
						roles: ['CopyrightMaintain']
					}
				},
				{
					path: '/AuditProcess',
					component: () => import('../components/page/ConfigurationCenter/AuditProcess'),
					meta: {
						title: '审核流程',
						roles: ['AuditProcess']
					}
				},
				{
					path: '/Superuser',
					component: () => import('../components/page/ConfigurationCenter/Superuser'),
					meta: {
						title: '授权管理',
						roles: ['Superuser']
					}
				},

				{
					path: '/CustomTemplate',
					component: () => import('../components/page/ConfigurationCenter/CustomTemplate'),
					meta: {
						title: '自定义模板',
						roles: ['CustomTemplate']
					}
				},
				{
					path: '/FieldProperties',
					component: () => import('../components/page/ConfigurationCenter/FieldProperties'),
					meta: {
						title: '字段属性',
						roles: ['FieldProperties']
					}
				},
				{
					path: '/sjtz',
					component: () => import('../components/page/ConfigurationCenter/sjtz'),
					meta: {
						title: '事件通知',
						roles: ['sjtz']
					}
				},
				{
					path: '/ConfigurationCenter',
					component: () => import('../components/page/ConfigurationCenter'),
					meta: {
						title: '配置中心',
						roles: ['ConfigurationCenter']
					}
				},
				{
					path: '/openInvoice',
					component: () => import('../components/mb/openInvoice'),
					meta: {
						title: '开票数据',
						roles: ['openInvoice']
					}
				},
				{
					path: '/contract',
					component: () => import('../components/mb/contract'),
					meta: {
						title: '合同台账',
						roles: ['contract']
					}
				},
				{
					path: '/redLetter',
					component: () => import('../components/mb/redLetter'),
					meta: {
						title: '红字信息表',
						roles: ['redLetter']
					}
				},
				{
					path: '/transport',
					component: () => import('../components/mb/transport'),
					meta: {
						title: '旅客运输',
						roles: ['transport']
					}
				},
				{
					path: '/inputCertification',
					component: () => import('../components/mb/input'),
					meta: {
						title: '进项认证',
						roles: ['inputCertification']
					}
				},
				{
					path: '/OperationLog',
					component: () => import('../components/page/operationLog'),
					meta: {
						title: '操作日志',
						roles: ['OperationLog']
					}
				},
				{
					path: '/todo',
					component: () => import('../components/page/todo'),
					meta: {
						title: '待办事项',
						roles: ['todo']
					}
				},
				{
					path: '/underreportingInspection',
					component: () => import('../components/page/underreportingInspection'),
					meta: {
						title: '漏报检查',
						roles: ['underreportingInspection']
					}
				},
				{
					path: '/taxInspection',
					component: () => import('../components/page/taxInspection'),
					meta: {
						title: '税种检查',
						roles: ['taxInspection']
					}
				},
				{
					path: '/declarationArchive',
					component: () => import('../components/page/declarationArchive'),
					meta: {
						title: '申报归档',
						roles: ['declarationArchive']
					}
				},
				{
					path: '/iinvsjclzx',
					component: () => import('../components/page/IinvTaxDiscrepancy/iinvsjclzx'),
					meta: {
						title: '数据处理中心',
						roles: ['iinvsjclzx']
					}
				},
				{
					path: '/iinvdkdj',
					component: () => import('../components/page/IinvTaxDiscrepancy/iinvdkdj'),
					meta: {
						title: '代扣代缴',
						roles: ['iinvdkdj']
					}
				},
				{
					path: '/iinvhgjks',
					component: () => import('../components/page/IinvTaxDiscrepancy/iinvhgjks'),
					meta: {
						title: '海关缴款书',
						roles: ['iinvhgjks']
					}
				},
				{
					path: '/iinvjxtjbyl',
					component: () => import('../components/page/IinvTaxDiscrepancy/iinvjxtjbyl'),
					meta: {
						title: '进项调节表一览',
						roles: ['iinvjxtjbyl']
					}
				},
				{
					path: '/auth',
					component: () => import('../components/page/ConfigurationCenter/zzsz/auth'),
					meta: {
						title: '报税登录',
						roles: ['auth'],
						requiresAuth: false, // 是否验证登录
						noLayout: true // 是否独立显示
					}
				}
			]
		},
		{
			path: '/Homepage',
			component: () => import( /* webpackChunkName: "home" */ '../components/page/Homepage'),
			meta: {
				title: '首页',
				roles: ['Homepage']
			},
		},
		{
			path: '/HomePageNew',
			component: () => import( /* webpackChunkName: "home" */ '../components/page/HomePageNew'),
			meta: {
				title: '驾驶舱',
				roles: ['HomePageNew']
			},
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "home" */ '../components/page/Login'),
			meta: {
				title: '登录'
			},
		},
		{
			path: '/mbsso',
			component: () => import('../components/mb/mbsso'),
			meta: {
				title: 'sso',
			}
		}

	]
});
